module.exports = __webpack_public_path__ + "img/chinesecompany142.e0e97ce6.png";